var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "chat-widget-dropdown",
    },
    [
      _vm.label
        ? _c("label", { staticClass: "chat-widget-dropdown__label" }, [
            _vm._v("\n    " + _vm._s(_vm.label) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "select",
        {
          staticClass:
            "chat-widget-dropdown__select form-control form-control-sm",
          attrs: { disabled: _vm.disabled },
          domProps: { value: _vm.selectedValue },
          on: {
            change: function ($event) {
              return _vm.onSelect($event.target.value)
            },
          },
        },
        [
          _vm.placeholder
            ? _c("option", { attrs: { value: "", disabled: "" } }, [
                _vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.options, function (option) {
            return _c(
              "option",
              { key: option.value, domProps: { value: option.value } },
              [_vm._v("\n      " + _vm._s(option.label) + "\n    ")]
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }